import { useLicenseStore } from '~/stores/license'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/fag')) return

  const store = useLicenseStore()
  const hasLicense = await store.executeLicenseCheck(to.params.subject || to.params.subjectSlug)
  if (hasLicense) return

  return navigateTo({ path: '/bestill-lisens' })
})
